<script setup>
</script>

<template>
<div class="notice">
	<h4>This article is loading from 'The Internet Archive'</h4>
	<p class="em">It may take 8–10 seconds to load.</p>
	<p>The Internet Archive is a free, community-funded web resource (like Wikipedia) that saves backups of websites.</p>
	<p>We don't want to waste their resources, so please give it a few more seconds before you refresh or change articles. <span class="emoji">✌️</span></p>
</div>
</template>

<style lang="scss" scoped>
.notice {
	background-color: var(--bg3);
	border-radius: 8px;
	border: 1px solid var(--border-warning);
	padding: 12px;
	margin-top: 16px;
}
.notice h4 {
	margin: 0;
}
.notice p {
	margin-top: .5em;
	margin-bottom: 0;
}
.notice p.em {
	font-weight: bold;
	color: var(--text-warning);
}
</style>
